import { render, staticRenderFns } from "./EduContinuaCalendario.vue?vue&type=template&id=73712eca&scoped=true"
import script from "./EduContinuaCalendario.vue?vue&type=script&lang=ts"
export * from "./EduContinuaCalendario.vue?vue&type=script&lang=ts"
import style0 from "./EduContinuaCalendario.vue?vue&type=style&index=0&id=73712eca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73712eca",
  null
  
)

export default component.exports